import { ReactNode, useState } from 'react';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import { BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import Image from 'next/image';
import Typography from '@alltrails/core/components/Typography';
import useUser from '@alltrails/context/hooks/useUser';
import usePlans from '@alltrails/context/hooks/usePlans';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import BaseUpsellModal from '../BaseUpsell/BaseUpsellModal';
import styles from '../FeatureUpsellModal.module.scss';
import PeakFeatureList from '../PeakFeatureList/PeakFeatureList';
import PlanSelection from '../PlanSelection/PlanSelection';
import getCtaText from '../getCtaText';

type Props = {
  headerImageSrc: StaticImport;
  heading: ReactNode;
  isOpen: boolean;
  onCloseRequest: () => void;
  promoEligibleHeading: ReactNode;
  upsellTrigger: UpsellTrigger;
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=5543-297520&t=9h0uykTwgb7vGafI-0
export default function PlusFeatureUpsellModal({ heading, promoEligibleHeading, onCloseRequest, headerImageSrc, isOpen, upsellTrigger }: Props) {
  const user = useUser();
  const plans = usePlans();
  const isPromoEligible = !user || user?.isPromoEligible;
  const [tierSelected, setTierSelected] = useState<PurchaseTier>('plus');

  return (
    <BaseUpsellModal
      headerImage={<Image alt="" className={styles.image} sizes={`(max-width: ${BREAKPOINT_SM_SIZE}px) 100vw, 480px`} src={headerImageSrc} />}
      heading={heading}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      primaryButtonText={getCtaText(tierSelected, user?.isPromoEligible)}
      promoEligibleHeading={promoEligibleHeading}
      purchaseTier={tierSelected}
      tallerOnMobile
      upsellTrigger={upsellTrigger}
      productsAvailable="plus-peak"
    >
      <>
        <Typography variant="heading400">{isPromoEligible ? promoEligibleHeading : heading}</Typography>
        <PlanSelection
          isPromoEligible={isPromoEligible}
          plans={plans}
          setTierSelected={setTierSelected}
          showPlusFirst
          subscriptionUser={user}
          tierSelected={tierSelected}
          trigger={upsellTrigger}
        />
        <PeakFeatureList hasHeaderScrollMargin tierSelected={tierSelected} upsellTrigger={upsellTrigger} />
      </>
    </BaseUpsellModal>
  );
}
